import { motion } from "framer-motion";

const TechStackSection = ({ techStack }) => {
  return (
    <div className="container py-5">
      {/* Header */}
      <div className="text-center mb-5">
        <span className="badge bg-primary bg-gradient text-light px-3 py-2 fs-6 mb-3">
          Technology Stack
        </span>
        <h2
          className="display-5 fw-bold"
          style={{
            background: "linear-gradient(to right, #2563eb, #1e3a8a)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
          }}
        >
          Cutting-Edge Technologies
        </h2>
        <p className="lead text-muted mx-auto" style={{ maxWidth: "720px" }}>
          We use the latest and most reliable technologies to build exceptional solutions.
        </p>
      </div>

      {/* Grid of Cards */}
      <div className="row g-4">
        {techStack.map((tech, idx) => {
          const Icon = tech.icon;
          return (
            <motion.div
              key={idx}
              className="col-12 col-md-6 col-lg-4"
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: idx * 0.1 }}
            >
              <div className="card border-0 shadow-lg h-100 text-center position-relative tech-card group cursor-pointer">
                <div className="card-body py-5 d-flex flex-column align-items-center">
                  {/* Icon Wrapper */}
                  <div className="position-relative mb-4">
                    <div
                      className="d-flex align-items-center justify-content-center rounded-4 shadow-lg mb-2"
                      style={{
                        width: "64px",
                        height: "64px",
                        background: "linear-gradient(to right, #3b82f6, #2563eb)",
                        transition: "box-shadow 0.3s",
                      }}
                    >
                      <Icon size={32} className="text-white" />
                    </div>
                    {/* Glow background */}
                    <div
                      className="position-absolute top-0 start-50 translate-middle-x rounded-4"
                      style={{
                        width: "64px",
                        height: "64px",
                        background: "linear-gradient(to right, #60a5fa, #2563eb)",
                        filter: "blur(20px)",
                        opacity: 0,
                        transition: "opacity 0.3s",
                      }}
                      data-glow
                    />
                  </div>

                  {/* Title */}
                  <h5 className="fw-semibold mb-2 text-dark group-hover:text-primary">
                    {tech.name}
                  </h5>

                  {/* Badge */}
                  <span className="badge bg-light text-primary border border-primary px-2 py-1">
                    {tech.category}
                  </span>
                </div>
              </div>
            </motion.div>
          );
        })}
      </div>
    </div>
  );
};
export default TechStackSection; 